import React, { useState } from 'react'
import './ConfirmModal.scss'
import PropTypes from 'prop-types'
import { deleteNotes } from 'src/helper/backendHelper'
import { toast } from 'react-toastify'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'

export default function DeleteNote({ visible, onChange, chart_id, handleClose }) {
  const [isClicked, setIsClicked] = useState(false)

  const handleClick = () => {
    if (chart_id) {
      deleteNotes(chart_id).then((res) => {
        if (res?.status === 'success') {
          toast.success('Visit notes deleted successfully')
          onChange()
        } else {
          toast.error('Note deletion failed')
          handleClose()
        }
        setIsClicked(false)
      })
    } else {
      // may be a lag issue and chart has
      // already been deleted
      setIsClicked(false)
    }
  }

  return (
    <CModal
      className="confirm-modal"
      visible={visible}
      onClose={handleClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Are you sure?</CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>Progress note draft will be deleted</div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          onClick={() => {
            if (!isClicked) {
              setIsClicked(true)
              handleClick()
            }
          }}
        >
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

DeleteNote.propTypes = {
  visible: PropTypes.bool,
  chart_id: PropTypes.string,
  onChange: PropTypes.func,
  handleClose: PropTypes.func,
}
